import React from 'react';

import { printMissingConfigError, SiteConfigManager } from '@atlas/core';
import { Label } from '@atlas/ui';

import StaticBlock from 'common/StaticBlock/StaticBlock';

const FooterMobileApplicationLink = () => {
  const showInFooter = SiteConfigManager.getConfig('config.config.applicationLink.showInFooter');
  const footerBlock = SiteConfigManager.getConfig('config.config.applicationLink.footerBlock');
  const url = SiteConfigManager.getConfig('config.config.applicationLink.url');
  const applicationName = SiteConfigManager.getConfig('config.config.applicationLink.name');

  if (showInFooter && (!footerBlock || !url || !applicationName)) {
    printMissingConfigError('config.config.applicationLink[footerBlock|url|name]');
  }

  if (!showInFooter) return null;

  return (
    <div className="footer-mobile-application-link">
      <Label className="block-title" message="footer_title_get_the_app" />
      <a aria-label={applicationName} href={url} rel="noreferrer" target="_blank">
        <StaticBlock options={{ source: footerBlock }} />
      </a>
    </div>
  );
};

export default FooterMobileApplicationLink;
